import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

const AddOptionsForm = () => {
  const [activeTab, setActiveTab] = useState(1);

  const [category, setCategory] = useState("");
  const [singleImageCategory, setSingleImageCategory] = useState(null); // For single image

  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post("https://server-gs.vercel.app/category", {
        category,
      });
      setMessage(response.data.message);
      setCategory(""); // Clear input after successful submission
      toast.success("Successfully added category");
    } catch (error) {
      setMessage("Error: Could not add category");
      console.error(error);
    }
  };

  const handleCategoryUploadSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("category", category);

    if (singleImageCategory) {
      formData.append("singleImage", singleImageCategory);
    }

    try {
      // Post the data to your backend
      const response = await axios.post(
        "https://server-gs.vercel.app/upload-category",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      console.log("Product added successfully:", response.data);
      toast.success("Product Upload Successfully");
    } catch (error) {
      console.error("Error adding product:", error);
    }
  };

  // Function to handle tab switching
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const [categories, setCategories] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get("https://server-gs.vercel.app/category");
        setCategories(response.data);
      } catch (error) {
        setError("Error fetching categories");
        console.error(error);
      }
    };

    // Fetch data immediately and then set interval
    fetchCategories();
    const intervalId = setInterval(fetchCategories, 1000); // Fetch every 2 seconds

    // Clear the interval when component unmounts
    return () => clearInterval(intervalId);
  }, []);
  //  add event

  // State to track the active tab

  const [EventTitle, setEventTitle] = useState("");

  const [singleImage, setSingleImage] = useState(null); // For single image

  // Fetch categories and companies on component mount

  // Handle image selection

  // Handle form submission
  const handleEventUploadSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("EventTitle", EventTitle);

    if (singleImage) {
      formData.append("singleImage", singleImage);
    }

    try {
      // Post the data to your backend
      const response = await axios.post(
        "https://server-gs.vercel.app/upload-events",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      console.log("Product added successfully:", response.data);
      toast.success("Product Upload Successfully");
    } catch (error) {
      console.error("Error adding product:", error);
    }
  };

  const [eventData, setEventData] = useState([]);

  useEffect(() => {
    const fetcheventData = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/eventCollection"
        );
        setEventData(response.data);
      } catch (error) {
        setError("Error fetching eventData");
        console.error(error);
      }
    };

    // Fetch data immediately and then set interval
    fetcheventData();
    const intervalId = setInterval(fetcheventData, 1000); // Fetch every 2 seconds

    // Clear the interval when component unmounts
    return () => clearInterval(intervalId);
  }, []);

  const handleDeleteEvent = async (productId) => {
    // Show a confirmation dialog
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this product? This action cannot be undone."
    );

    if (confirmDelete) {
      try {
        await axios.delete(
          `https://server-gs.vercel.app/deleteEventCollection/${productId}`
        );
        // Filter out the deleted product from the state
        setEventData(eventData.filter((product) => product._id !== productId));
        alert("Product deleted successfully.");
      } catch (error) {
        console.error("Error deleting product:", error);
        alert("Failed to delete the product. Please try again.");
      }
    }
  };

  const handleDeleteCategory = async (productId) => {
    // Show a confirmation dialog
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this product? This action cannot be undone."
    );

    if (confirmDelete) {
      try {
        await axios.delete(`https://server-gs.vercel.app/deleteCategory/${productId}`);
        // Filter out the deleted product from the state
        setEventData(eventData.filter((product) => product._id !== productId));
        alert("Product deleted successfully.");
      } catch (error) {
        console.error("Error deleting product:", error);
        alert("Failed to delete the product. Please try again.");
      }
    }
  };

  return (
    <div className="flex flex-col">
      {/* Button navigation */}
      <div className="flex justify-between items-center mb-6">
        <button
          className={`font-roboto duration-300 text-xl pb-2 border-b w-full border-gray-500 ${
            activeTab === 1
              ? "text-blue-600 border-b-2  border-b-blue-600"
              : "text-gray-500"
          }`}
          onClick={() => handleTabClick(1)}
        >
          Add Category / Rental
        </button>
        <button
          className={`font-roboto text-xl pb-2 border-b w-full border-gray-500 ${
            activeTab === 2
              ? "text-blue-600 border-b-2 border-b-blue-600"
              : "text-gray-500"
          }`}
          onClick={() => handleTabClick(2)}
        >
          Add Events
        </button>
      </div>
      {activeTab === 1 && (
        <div>
          <div className="flex flex-col justify-between gap-5 ">
            <form
              onSubmit={handleCategoryUploadSubmit}
              className="flex flex-col gap-3 w-[80%]"
            >
              <div className="flex flex-row gap-5  w-full justify-between items-center">
                <div className="flex flex-col w-full">
                  <label className="text-xl  text-black font-roboto">
                    Category Title
                  </label>
                  <input
                    type="text"
                    value={category}
                    className="bg-white border-2 border-gray-400 rounded w-full h-10 px-2 mt-2 font-roboto"
                    onChange={(e) => setCategory(e.target.value)}
                    placeholder="Enter category"
                    required
                  />
                </div>
                <div className="flex flex-col w-56">
                  <label className="text-xl  text-black font-roboto">
                    Upload Single Image
                  </label>
                  <input
                    type="file"
                    className="mt-2 text-blue"
                    onChange={(e) => setSingleImageCategory(e.target.files[0])}
                  />
                </div>
              </div>
              <button
                className="bg-blue-700 font-roboto rounded text-white py-2 w-56"
                type="submit"
              >
                Add Category
              </button>
            </form>
            <div className="h-[400px] overflow-auto bg-gray-50 rounded p-5 w-full">
              <div class="relative overflow-x-auto">
                <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th scope="col" class="px-6 py-3">
                        Index
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Image
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Name
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Delete
                      </th>
                    </tr>
                  </thead>
                  {categories.map((category, index) => (
                    <tbody>
                      <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                        <th
                          scope="row"
                          class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          {index + 1}
                        </th>
                        <th
                          scope="row"
                          class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          <img
                            class="w-10 h-10 rounded-full"
                            src={category.singleImage}
                            alt="Rounded avatar"
                          />
                        </th>
                        <td class="px-6 py-4">{category.category}</td>
                        <td class="px-6 py-4">
                          <button
                            onClick={() => handleDeleteCategory(category._id)}
                            class="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                          >
                            <svg
                              class="text-gray-400 dark:text-gray-500 w-6 h-6 mb-3.5 mx-auto"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </div>
          </div>
          <div></div>
        </div>
      )}
      {activeTab === 2 && (
        <div>
          <form
            className="w-[80%]"
            onSubmit={handleEventUploadSubmit}
            encType="multipart/form-data"
          >
            <div className="flex flex-row gap-5 w-full justify-between">
              <div className="flex flex-col w-full">
                <label className="text-xl text-gray-700 font-roboto">
                  Event Title
                </label>
                <input
                  type="text"
                  value={EventTitle}
                  className="border border-gray-400  bg-white h-10  rounded  mt-2 p-2"
                  onChange={(e) => setEventTitle(e.target.value)}
                />
              </div>
              <div className="flex flex-col w-56">
                <label className="text-xl  text-black font-roboto">
                  Upload Single Image
                </label>
                <input
                  type="file"
                  className="mt-2 text-blue"
                  onChange={(e) => setSingleImage(e.target.files[0])}
                />
              </div>
            </div>

            <div className="w-full flex justify-start mt-5">
              <button
                className="bg-blue-600 px-4 py-1 rounded text-lg font-roboto text-white "
                type="submit"
              >
                Add Event
              </button>
            </div>
          </form>
          <div className="h-[350px] mt-3 overflow-auto bg-gray-50 rounded p-5 w-full">
            <div class="relative overflow-x-auto">
              <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th scope="col" class="px-6 py-3">
                      Index
                    </th>
                    <th scope="col" class="px-6 py-3">
                      Name
                    </th>
                    <th scope="col" class="px-6 py-3">
                      Delete
                    </th>
                  </tr>
                </thead>

                {eventData.map((category, index) => (
                  <tbody>
                    <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <th
                        scope="row"
                        class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                      >
                        {index + 1}
                      </th>
                      <th
                        scope="row"
                        class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                      >
                        <img
                          class="w-10 h-10 rounded-full"
                          src={category.singleImage}
                          alt="Rounded avatar"
                        />
                      </th>
                      <td class="px-6 py-4">{category.EventTitle}</td>
                      <td class="px-6 py-4">
                        <button
                          onClick={() => handleDeleteEvent(category._id)}
                          class="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                        >
                          <svg
                            class="text-gray-400 dark:text-gray-500 w-6 h-6 mb-3.5 mx-auto"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                              clip-rule="evenodd"
                            ></path>
                          </svg>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddOptionsForm;
